var _mask, _g, _mask2, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgSelfServiceBee = function SvgSelfServiceBee(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 6,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.97707 3H2.00301C2.04626 3.00058 2.08984 3.00406 2.13352 3.01058C2.17167 3.01643 2.20982 3.02436 2.24797 3.03475C3.96533 3.50408 5.97298 6.07738 6.59 6.91538L6.59473 6.9218C6.63061 6.97053 6.66121 7.01265 6.68708 7.04853L6.83685 7.25402L6.78945 7.42135C6.24532 8.90263 4.98502 9.28055 4.00424 9.13418C3.43953 9.04976 2.96736 8.79177 2.77812 8.47032C2.75753 8.43538 2.74073 8.39892 2.72788 8.36191C2.63496 8.09542 2.73959 7.79153 2.99211 7.64289C3.08918 7.58567 3.19721 7.53675 3.31356 7.49482C3.40799 7.46102 3.50922 7.43344 3.61329 7.40832L3.60932 7.40757L3.1075 7.15581L3.11506 7.15165C2.00906 6.5656 1.26889 5.51324 1.06057 4.60952C0.985216 4.2824 0.978794 3.97568 1.04905 3.71901C1.16638 3.28943 1.55301 3.00568 1.97708 3H1.97707Z",
    fill: "#4D5A79"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-32.7971 15.0782H15V3H-32.7971V15.0782Z",
    fill: "#4D5A79"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 3,
    width: 6,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.997 3H14.0229C14.4469 3.00568 14.8335 3.28943 14.951 3.71901C15.0213 3.97568 15.0148 4.2824 14.9395 4.60952C14.7312 5.51324 13.991 6.5656 12.885 7.15165L12.8926 7.15581L12.3907 7.40757L12.3868 7.40832C12.4908 7.43344 12.5921 7.46102 12.6863 7.49482C12.8028 7.53675 12.9109 7.58567 13.0078 7.64289C13.2603 7.79153 13.3651 8.09542 13.2722 8.36191C13.2591 8.39892 13.2425 8.43538 13.2219 8.47032C13.0325 8.79177 12.5605 9.04976 11.9958 9.13418C11.015 9.28055 9.75455 8.90263 9.21061 7.42135L9.16321 7.25402L9.31241 7.04929C9.33829 7.01321 9.36907 6.9711 9.40515 6.92199L9.41006 6.91538C10.0271 6.07738 12.0347 3.50408 13.7521 3.03475C13.7902 3.02436 13.8284 3.01643 13.8665 3.01058C13.9102 3.00406 13.9538 3.00058 13.997 3Z",
    fill: "#4D5A79"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-32.797 15.0782H15.0001V3H-32.797V15.0782Z",
    fill: "#4D5A79"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28749 5.11836C9.28749 5.37238 9.12733 5.59865 8.88785 5.68307L8.02888 5.98582C7.99508 5.99791 7.95806 5.99791 7.92425 5.98582L7.06529 5.68307C6.82581 5.59865 6.66565 5.37238 6.66565 5.11836C6.66565 4.78765 6.93384 4.51965 7.26454 4.51965H8.68859C9.0193 4.51965 9.28749 4.78765 9.28749 5.11836Z",
    fill: "#4D5A79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92871 5.39893C7.9442 5.40459 7.96025 5.40724 7.97649 5.40724C7.96044 5.40724 7.9442 5.4044 7.92871 5.39893Z",
    fill: "#4D5A79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26063 3.60435L7.97658 3.25891L7.69252 3.60435L7.22961 3.25891V4.16755H8.72354V3.25891L8.26063 3.60435Z",
    fill: "#4D5A79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98999 10.1282H5.94995C5.95297 10.1563 5.956 10.1848 5.95902 10.212C5.99207 10.5214 6.05572 10.8277 6.1526 11.1231H9.77997C9.88423 10.7992 9.95184 10.4606 9.98999 10.1282Z",
    fill: "#4D5A79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3562 11.6207C6.58548 12.0653 6.92393 12.4529 7.35493 12.7111C7.50451 12.8008 7.81878 13.0055 8.00897 12.9605C8.77577 12.7798 9.2723 12.261 9.58222 11.6207H6.3562Z",
    fill: "#4D5A79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0262 9.63068C10.026 9.26919 9.95295 8.89788 9.60638 8.70996C9.19106 8.48464 8.64241 8.53469 8.18743 8.53734C7.56568 8.54074 6.33654 8.33827 6.01679 9.06522C5.94087 9.23803 5.91669 9.43313 5.9165 9.63068H10.0262Z",
    fill: "#4D5A79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33915 7.24681C9.33915 7.99907 8.72912 8.6091 7.97667 8.6091C7.22423 8.6091 6.61438 7.99907 6.61438 7.24681C6.61438 6.49437 7.22423 5.88452 7.97667 5.88452C8.72912 5.88452 9.33915 6.49437 9.33915 7.24681Z",
    fill: "#4D5A79"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelfServiceBee, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/self_service_bee.3db619a5da8da1795bfbcedf44c66589.svg";
export { ForwardRef as ReactComponent };